import { render } from "./ModalTransferUsdt.vue?vue&type=template&id=3980fd54&scoped=true&ts=true"
import script from "./ModalTransferUsdt.vue?vue&type=script&lang=ts"
export * from "./ModalTransferUsdt.vue?vue&type=script&lang=ts"

import "./ModalTransferUsdt.vue?vue&type=style&index=0&id=3980fd54&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3980fd54"]])

export default __exports__